import { render, staticRenderFns } from "./PopoverRedirect.vue?vue&type=template&id=7ad780c6&scoped=true&"
import script from "./PopoverRedirect.vue?vue&type=script&lang=js&"
export * from "./PopoverRedirect.vue?vue&type=script&lang=js&"
import style0 from "./PopoverRedirect.vue?vue&type=style&index=0&id=7ad780c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad780c6",
  null
  
)

export default component.exports